class Stream {
  private _stream: VideoStream | null = null;

  constructor (videoStream: VideoStream) {
    this._stream = videoStream;
  }

  public isStreamDirectFromCamera(): boolean {
    try {
      return this._stream?.sourceType === "CAMERA";
    } catch (e) {
      console.log(e);
      return false;
    }
  }

  public isAxis(): boolean {
    try {
      const isAxis: boolean = this._stream?.manufacturer === "Axis";
      return isAxis;
    } catch (e) {
      console.log(e);
      return false;
    }
  }

  public isAOASupported(): boolean {
    try {
      const isModelSupported = [
        "P1468-XLE",
        "XFQ1656",
        "M1055-L",
        "M1075-L",
        "M1135",
        "M1135-E",
        "M1137",
        "M1137-E",
        "P1385",
        "P1385-B",
        "P1385-BE",
        "P1385-E",
        "P1387",
        "P1387-B",
        "P1387-BE",
        "P1387-LE",
        "P1388",
        "P1388-B",
        "P1388-BE",
        "P1388-LE",
        "Q1615-LE",
        "Q1656",
        "Q1656-B",
        "Q1656-BE",
        "Q1656-BLE",
        "Q1656-DLE",
        "Q1656-LE",
        "Q1686-DLE",
        "Q1715",
        "M2035-LE",
        "M2036-LE",
        "P1455-LE",
        "P1465-LE",
        "P1467-LE",
        "P1468-LE",
        "Q1805-LE",
        "Q1806-LE",
        "Q1808-LE",
        "M3085-V",
        "M3086-V",
        "M3088-V",
        "M3125-LVE",
        "M3126-LVE",
        "M3128-LVE",
        "M3215-LVE",
        "M3216-LVE",
        "M4215-LV",
        "M4215-V",
        "M4216-LV",
        "M4216-V",
        "M4218-LV",
        "M4218-V",
        "M4308-PLE",
        "P3255-LVE",
        "P3265-LV",
        "P3265-LVE",
        "P3265-V",
        "P3267-LV",
        "P3267-LVE",
        "P3268-LV",
        "P3268-LVE",
        "P3268-SLVE",
        "P3827-PVE",
        "P4705-PLVE",
        "P4707-PLVE",
        "P9117-PV",
        "Q3536-LVE",
        "Q3538-LVE",
        "Q3538-SLVE",
        "Q3626-VE",
        "Q3628-VE",
        "Q3819-PVE",
        "Q9307-LV",
        "F9104-B",
        "F9111",
        "F9114",
        "F9114-B",
        "P1245",
        "P1265",
        "P1275",
        "I8116-E",
        "M5526-E",
        "P5654-E",
        "P5655-E",
        "P5676-LE",
        "Q6074",
        "Q6074-E",
        "Q6075",
        "Q6075-E",
        "Q6078-E",
        "Q6135-LE",
        "Q6225-LE",
        "Q6315-LE",
        "Q6318-LE",
        "M4308-PLE",
        "M4317-PLR",
        "M4317-PLVE",
        "M4318-PLR",
        "M4318-PLVE",
        "M4327-P",
        "M4328-P",
        "P3735-PLE",
        "P3737-PLE",
        "P3738-PLE",
        "P3827-PVE",
        "P4705-PLVE",
        "P4707-PLVE",
        "P4708-PLVE",
        "Q3819-PVE",
        "P3747-PLVE",
        "Q1800-LE"
      ].includes(this._stream?.cameraModel || "");

      return isModelSupported === true;
    } catch (e) {
      console.log(e)
      return true;
    }
  }
}

export default Stream;
